import { FC } from "react";

export type VerticalPaddingValues = 'none' | 'small' | 'medium' | 'large';

/*
 * Padding values correspond to `margin-section-md` and `margin-section-lg` variables in the design system
 * margin-section-md: 120px on desktop, 64px on mobile
 * margin-section-lg: 160px on desktop, 80px on mobile
 */

const VerticalPaddingValuesMap = {
  none: '',
  small: 'py-4 md:py-10',
  medium: 'py-8 md:py-15',
  large: 'py-10 md:py-20',
}

const TopPaddingValuesMap = {
  none: '',
  small: 'pt-4 md:pt-10',
  medium: 'pt-8 md:pt-15',
  large: 'pt-10 md:pt-20',
}

const BottomPaddingValuesMap = {
  none: '',
  small: 'pb-4 md:pb-10',
  medium: 'pb-8 md:pb-15',
  large: 'pb-10 md:pb-20',
}

type VerticalPaddingWrapperProps = {
  children: React.ReactNode;
  paddingTop?: VerticalPaddingValues;
  paddingBottom?: VerticalPaddingValues;
}

const VerticalPaddingWrapper: FC<VerticalPaddingWrapperProps> = ({ children, paddingTop = 'medium', paddingBottom = 'medium' }) => {

  if (paddingTop == paddingBottom) {
    return <div className={`${VerticalPaddingValuesMap[paddingTop]}`}>{children}</div>;
  }

  return <div className={`${TopPaddingValuesMap[paddingTop]} ${BottomPaddingValuesMap[paddingBottom]}`}>{children}</div>;
};

export default VerticalPaddingWrapper;
